
import type { SVGProps } from 'react';
const SvgPerson = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={72}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#person_svg__a)">
      <path
        fill="#263E6A"
        d="M12 11.385a2.9 2.9 0 0 1-2.119-.882A2.9 2.9 0 0 1 9 8.385q0-1.238.881-2.12A2.9 2.9 0 0 1 12 5.386q1.237 0 2.119.88.88.882.881 2.12 0 1.237-.881 2.118a2.9 2.9 0 0 1-2.119.882m-7 7.23V16.97q0-.62.36-1.158.361-.54.97-.838a14.2 14.2 0 0 1 2.833-1.018 12 12 0 0 1 2.837-.34q1.42 0 2.836.34 1.418.34 2.833 1.018.61.298.97.838T19 16.969v1.646zm1-1h12v-.646q0-.333-.214-.625a1.7 1.7 0 0 0-.594-.494 12.7 12.7 0 0 0-2.546-.916 11.2 11.2 0 0 0-5.292 0q-1.312.318-2.546.916-.379.203-.594.494A1.04 1.04 0 0 0 6 16.97zm6-7.23q.825 0 1.412-.588Q14 9.21 14 8.385t-.588-1.413A1.93 1.93 0 0 0 12 6.385q-.825 0-1.412.587A1.93 1.93 0 0 0 10 8.385q0 .824.588 1.412.587.588 1.412.588"
      />
    </g>
    <g clipPath="url(#person_svg__b)">
      <path
        fill="#263E6A"
        d="M60 11.385a2.9 2.9 0 0 1-2.119-.882A2.9 2.9 0 0 1 57 8.385q0-1.238.881-2.12A2.9 2.9 0 0 1 60 5.386a2.9 2.9 0 0 1 2.119.88q.88.882.881 2.12 0 1.237-.881 2.118a2.9 2.9 0 0 1-2.119.882m-7 7.23V16.97q0-.62.36-1.158.361-.54.97-.838a14.2 14.2 0 0 1 2.833-1.018q1.417-.34 2.837-.34t2.837.34q1.417.34 2.832 1.018.61.298.97.838T67 16.969v1.646z"
      />
    </g>
    <defs>
      <clipPath id="person_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
      <clipPath id="person_svg__b">
        <path fill="#fff" d="M48 0h24v24H48z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPerson;
